export const filterEmpty = (el: unknown): boolean => el !== "";
